export class ExportAccessDeniedItemsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "S3RestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExportAccessDeniedItemsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
